import { TopBarThemedThemeSizeConfig } from './types';

const small: TopBarThemedThemeSizeConfig = {
  topBarThemed: {},
};

export default small;
